<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
.col-sm-6.form-inline.p-0 {
  float: right;
}
.col-sm-6.p-0 {
  float: left;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white d-flex align-items-center font-weight-bold">
      Jadwal Test Center
    </CCardHeader>
    <!-- Data Jadwal TC -->
    <CCardBody>
        <CRow>
        
        <div class="col-sm-12 col-xl-12">
          <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Test Center</label>
            <multiselect
              class="mulit-select"
              label="namaTc"
              placeholder="Pilih Test Center"
              :show-labels="false"
              @select="pilihTc"
              v-model="formData.dataTestCenter"
              required
              :options="namaTc"
            ></multiselect>
          </div>
        </div>
        </CRow>
        <CRow>        
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable 
            style="widht:100% !important" 
            :items="items" 
            :fields="fields"
            :items-per-page-select='{ label : "Data Per Halaman", class: "float-right" }'  
            :tableFilter='{ label:"Pencarian", placeholder:"Cari Data ..", class: "float-left" }'
            :items-per-page="10"
            :pagination='{ class: "float-right" }'
            hover 
            sorter>
            <template #no="{ index}">
              <td class="py-2">{{ index += 1 }}</td>
            </template>
            <template #waktu="{item}">
              <td class="py-2 text-center">{{item.waktu ? item.waktu : "-"}}</td>
            </template>
            <template #sesi="{item}">
              <td class="py-2 text-left">{{item.sesi ?  item.sesi : "-"}}</td>
            </template>
            <template #kapasitas="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.kapasitas ? item.kapasitas : "-"}}</td>
            </template>         
          </CDataTable>
          
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <div class="modal-body">
              <form>
                <div class="form-row">              
                  <div class="form-group col-md-12">
                    <label for="level" class="font-weight-bold">Test Center</label>
                    <multiselect
                      class="mulit-select"
                      label="namaTc"
                      placeholder="Pilih Nama TC"
                      :show-labels="false"
                      @select="updateSelect"
                      v-model="formData.dataTestCenter"
                      required
                      :options="namaTc"
                    ></multiselect>                    
                  </div>
                  <div class="form-group col-md-12">
                    <label for="tgl" class="font-weight-bold">Pilih Tanggal {{ formData.sesi_tc }}</label>
                    <input
                      type="date"
                      class="form-control"
                      id="datePicker"
                      placeholder="Masukkan Nama Kupon"
                      v-model="formData.tanggalPelaksanaan"
                      required
                    />
                  </div>
                  <div
                    class="form-group col-md-12"
                    v-for="(input,k) in formData.sesi_tc"
                    :key="k"
                  >
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label for="nama_dok" class="font-weight-bold">Sesi</label>
                      <input type="text" name="" class="form-control" id="" readonly v-model="input.sesi">
                    </div>
                    <div class="form-group col-md-4">
                      <label for="nama_dok" class="font-weight-bold">Waktu</label>
                      <input type="text" name="" class="form-control" id="" v-model="input.waktu">
                    </div>
              
                    <div class="col-1 d-flex align-items-center">
                      <div
                        class="btn btn-sm btn-success ml-2 mt-2"
                        @click="add_sesi(k)"
                        v-show="k == formData.sesi_tc.length-1"
                      >
                        <i class="fa fa-plus" aria-hidden="true"></i>
                      </div>
                      <div
                        class="btn btn-sm btn-danger ml-2 mt-2"
                        @click="remove_sesi(k)"
                        v-show="k || ( !k && formData.sesi_tc.length > 1)"
                      >
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                    
                  </div>
                  
                  <div class="form-group col-md-12">
                    <label for="kapasitas" class="font-weight-bold">Kapasitas</label>
                    <input
                      type="number"
                      class="form-control"
                      id="kapasitas"
                      placeholder="Masukkan kapasitas"
                      v-model="formData.kapasitas"
                      required
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <!-- <label for="sisa" class="font-weight-bold">Sisa</label> -->
                    <input
                      type="hidden"
                      class="form-control"
                      :id="'sisa'+k"
                      placeholder="Terisi Otomatis"
                      disabled
                      v-model="formData.kapasitas"
                    />
                  </div>
                </div>
              </form>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{title}}</h6>          
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data Jadwal TC -->
  </CCard>
</template>
<script>
import MasterJadwalTcService from "../../services/sertifikasi/jadwal-tc.service.js";
import DataTestCenterServices from "../../services/datamaster/data-test-center.service";
import { Pagination } from "../../mixins/Pagination";

const fields = [
  { key: "no" },
  {
    key: "nama_tc",
    label: "Test Center",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "tanggal_ujian",
    label: "Tanggal Ujian",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "sesi",
    label: "Sesi",
    _style: "width: 15%; vertical-align: middle;",
    sorter: true,
    filter: false
  },
  {
    key: "waktu",
    label: "Waktu",
    _style: "width: 15%; vertical-align: middle;",
    sorter: true,
    filter: false
  },
  {
    key: "kapasitas",
    label: "Kapasitas",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;text-align:center"
  },
  // {
  //   key: "sisa",
  //   label: "Sisa",
  //   sorter: true,
  //   filter: false,
  //   _style: "vertical-align: middle;"
  // },
 
];

export default {
 
  name: "JadwalTC",
  data() {
    return {
      items : [],
      idTc : '',
      cariData : '',
      multi_kategori: [
        {
          namaTc: "",
          kodeTc: ""
        }
      ],
      dataTable : [],
      TestCenter: [],
      actionPost: "",
      namaTc: [],
      formData: {
        dataTestCenter: '',
        sesi_tc : [
          
        ],
        kodeTc: "",
        sesiSatu: "",
        sesiDua: "",
        sesiTiga: "",
        sisa: "",
        tanggalPelaksanaan: "",
        status: ""
      },
     
      k: "",
      title: "",
      fields,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      fileName: "Choose File...",
      content: [],
      loading: true
    };
  },
  watch : {
    cariData : function(value) {
      var resultObject = this.cariDataItem(value, this.items);
    }
  },
  mounted() {
    this.getTestCenter();    
    setTimeout(() => {
      this.getData(this.formData.dataTestCenter.idTc, 0, 10, 'default')
    }, 1000)
  },
  methods: {    
    pilihTc(value) {
      this.idTc = value.idTc;
      this.getData(this.idTc,0,10,'default')
    },
    add_sesi(index) {
      this.formData.sesi_tc.push({
        id_sesi : "",
        sesi : "",
        waktu : ""
      });
      // comment console console.log(this.formData.sesi_tc);
    },

    remove_sesi(index) {
      this.formData.sesi_tc.splice(index, 1);
    },
    sisa(event, k) {
      var data = event.target.value.split(".");
      document.getElementById("sisa" + k).value = data[1];
      // comment console console.log(k);
    },
    updateSelect(event) {
      var vm = this;
      this.formData.namaTc = event.namaTc;
    },
   
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    deleteData(item, index) {
      var vm = this;
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            let loader = this.$loading.show({
              container: false ? null : this.$refs.formContainer,
              canCancel: true,
              onCancel: this.onCancel
            });
            MasterJadwalTcService.deleteJadwalTc(this.formData)
              .then(response => {
                // comment console console.log(response);
                loader.hide();
                vm.alertSuccess();
                vm.getData("0");
              })
              .catch(error => {
                loader.hide();
                vm.alertError();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            vm.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(idTc,currentPage,pageSize,filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      MasterJadwalTcService.getJadwalTcWithIdTc(idTc,currentPage,pageSize,filter)
      .then(response => {
        this.items = response.data.data;
        loader.hide()
      }).catch(error => {
        // comment console console.log(error);
        loader.hide()
      })
    },

    getTestCenter() {
      var vm = this;
      DataTestCenterServices.getDataTestCenter("0",10000000,"default")
        .then(response => {
          vm.namaTc = response.data.data.content;          
          vm.namaTc.filter(el => el.idTc !== "semua");
          vm.formData.dataTestCenter = vm.namaTc[0]
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    createData() {
      this.$router.push({ path : "/sertifikasi/jadwal-tc-tambah"})
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.actionPost = "update";
      this.title = "Edit";
    },

    postData() {
      if (this.actionPost == "insert") {
        this.insertData(this.formData);
      } else if (this.actionPost == "update") {
        this.putData();
      }
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      this.formData.tanggalPelaksanaan =
        this.formData.tanggalPelaksanaan + " 12:00:00";
      // comment console console.log(formData);
      // comment console console.log("post");
      var vm = this;
      MasterJadwalTcService.postJadwalTc(formData)
        .then(response => {
          vm.myModal = false;
          loader.hide();
          vm.alertSuccess();
          vm.getData("0");
        })
        .catch(error => {
          // comment console console.log(error);
          vm.alertError();
        });
    },

    putData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      this.formData.tanggalPelaksanaan =
        this.formData.tanggalPelaksanaan + " 12:00:00";
      // comment console console.log("put");
      // comment console console.log(this.formData);
      var vm = this;
      MasterJadwalTcService.putJadwalTc(this.formData)
        .then(response => {
          vm.myModal = false;
          loader.hide();
          vm.alertSuccess();

          vm.getData("0");
        })
        .catch(error => {
          // comment console console.log(error);

          vm.alertError();
        });
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>